import { createSlice } from '@reduxjs/toolkit';
import { appThemeEnum } from '../../classes/enums/AppThemeEnum';

const initialState = {
  isPopupOpen: false,
  isProcessing: false,
  runningProcess: "",
  theme: appThemeEnum.Light
};

export const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    startProcess: (state, action) => {
      state.isProcessing = true;
      state.runningProcess = action.payload;
    },
    stopProcess: (state) => {
      state.isProcessing = false;
      state.runningProcess = "";
    },
    changeTheme: (state, action) => {
      state.theme = action.payload;
    },
    openPopup:(state) => {
      state.isPopupOpen = true;
    },
    closePopup:(state) => {
      state.isPopupOpen = false;
    }
  }
});

export const { startProcess, stopProcess, changeTheme, openPopup, closePopup } = applicationSlice.actions;
export default applicationSlice.reducer;